/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import Page from "components/common_components/Page";
import Button from "components/common_components/Button";
import Icon from "components/common_components/Icon";
import Status from "components/common_components/Status";
import { Form } from "components/common_components/Formik";
import { notifyError, notifySuccess, notifyInfo } from "redux/actions/Notifications";
import CampaignsContext from "./CampaignsContext";
import CampaignBasicFields from "./components/CampaignBasicFields";
import { basicCampaignSchema } from "./validation";
import { buildCampaignPayload } from "./utils";

const INITIAL_VALUES = {
    name: "",
    description: "",
    startDatetime: null,
    endDatetime: null,
};

function AddCampaign() {
    const history = useHistory();
    const dispatch = useDispatch();
    const { Campaigns, cloneState, setCloneState } = useContext(CampaignsContext);

    const isCloning = Boolean(cloneState);
    const initialValues = isCloning ? { ...INITIAL_VALUES, ...cloneState.basic } : INITIAL_VALUES;

    const onCancel = () => {
        setCloneState(null);
        history.push("/campaigns");
    };

    const onSubmit = (values, { setSubmitting }) => {
        Campaigns.add({
            payload: buildCampaignPayload(values, { includeAssets: false }),
            onSuccess: (newId) => {
                setSubmitting(false);
                dispatch(notifySuccess("Campaign created successfully!"));
                if (isCloning) {
                    // Keep the original assets in session so the edit page can
                    // preload and clone them into the new campaign on save.
                    setCloneState({ ...cloneState, newCampaignId: newId });
                    dispatch(notifyInfo("Review the cloned assets and save to finish."));
                } else {
                    dispatch(notifyInfo("Now you can add assets to your campaign."));
                }
                history.push(`/campaigns/${newId}/edit`);
            },
            onError: (error) => {
                dispatch(notifyError(error.message || error));
                setSubmitting(false);
            },
        });
    };

    return (
        <Page className="campaign-form-page">
            <div className="form-head">
                <div className="item back">
                    <Button secondary link small onClick={onCancel}>
                        <Icon name="arrow" size="sm" color="secondary" />
                        <span>Back</span>
                    </Button>
                </div>
                <div className="item form-status">
                    <Status id="CREATED" withIcon />
                </div>
                <div className="item title">
                    <h2>{isCloning ? "Clone campaign" : "New campaign"}</h2>
                </div>
            </div>

            <div className="campaign-form">
                <p className="campaign-form__hint">
                    {isCloning
                        ? "Review the basic information for the cloned campaign. After saving, its assets will be preloaded in the edit view."
                        : "Create the campaign with its basic information. After saving, you will be able to add assets (banners) in the edit view."}
                </p>
                <Form
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={basicCampaignSchema}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                >
                    <CampaignBasicFields />
                </Form>
            </div>
        </Page>
    );
}

export default AddCampaign;
